import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useState } from "react";
import ReactHtmlParser from "react-html-parser";
import CommonService from "../../services/common.service";
import Loader from "../Common/Loader";
import moment from "moment/moment";
import DashboardService from "../../services/dashboard.service";
import { useSelector } from "react-redux";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";

const AboutGame = (props) => {
  useAutoAddQueryString();
  const { game_info_block_data } = useSelector((state) => state.dashboard);
  let [searchParams] = useSearchParams();
  var accountName = searchParams.get("account_name");
  const [isLoading, setIsLoading] = useState(false);
  const [welcomeMessage, setWelcomeMessage] = useState(false);
  const [gameData, setGameData] = useState(false);
  const clubDetails = JSON.parse(localStorage.getItem("club_details"));
  useEffect(() => {
    getGameData();
    getUserDetails();
  }, []);
  const getGameData = () => {
    CommonService.getGameDetails(clubDetails?.id).then((res) => {
      if (res.status === 200) {
        setGameData(res.data);
      }
    });
  };

  const [roundData, setRoundData] = useState([]);
  const [currentRoundDetails, setCurrentRoundDetails] = useState({});
  const [nextRoundDetails, setNextRoundDetails] = useState({});
  const [isCurrent, setIsCurrent] = useState("");
  const [currentTradeWindowDetails, setCurrentTradeWindowDetails] = useState(
    {}
  );
  const getUserDetails = () => {
    CommonService.getCurrentRoundDetail().then((res) => {
      if (res.status === 200) {
        setCurrentRoundDetails(res.data);
        setNextRoundDetails(res.nextRoundDetails);
        setIsCurrent(res.isCurrent);
      }
    });
    CommonService.getUserDetail().then((res) => {
      if (res.success) {
        setRoundData(res.data?.get_round);
        setIsLoading(false);
      }
    });
    CommonService.getTradingWindows().then((res) => {
      setCurrentTradeWindowDetails(res.currentTradeWindowDetails);
      setNextTradeWindowDetails(res.nextTradeWindowDetails);
    });
  };

  const [lockoutList, setLockoutList] = useState([]);
  const [nextTradeWindowDetails, setNextTradeWindowDetails] = useState({});
  const fetchTradeData = () => {
    DashboardService.getTradingListing().then((res) => {
      setLockoutList(res.data);
      setIsCurrent(res.isCurrent);
      setIsLoading(false);
    });
  };

  //   Point system Logic start here
  const [selectedGrade, setSelectedGrade] = useState(0);
  const [pointsListing, setPointsListing] = useState([]);
  const [gradeList, setGradeList] = useState([]);
  const handleGradeChange = (value) => {
    setSelectedGrade(value);
    CommonService.getGradePointSystem(selectedGrade).then((res) => {
      setPointsListing(res.data);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchRoundData();
    getDefaultPointSystem();
  }, []);

  const fetchRoundData = () => {
    CommonService.getGradeList().then((res) => {
      setGradeList(res.data);
      setIsLoading(false);
    });
  };

  const [bonusPoints, setBonusPoints] = useState([]);
  const fetchBonusPoints = () => {
    CommonService.getBonusPoint().then((res) => {
      setBonusPoints(res.data);
    });
  };
  const getDefaultPointSystem = () => {
    CommonService.getDefaultPointSystem(selectedGrade).then((res) => {
      setPointsListing(res.data);
      setSelectedGrade(res.gradeId);
      setIsLoading(false);
    });
  };
  //   Point system Logic finish here
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="step-collapse">
              <div className="whitebox">
                <h2>
                  <a
                    className="collapsed"
                    data-bs-toggle="collapse"
                    href="#collapsestep"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapsestep"
                  >
                    Welcome
                  </a>
                </h2>
                {gameData?.entry_message && (
                  <div className="auditstep collapse" id="collapsestep">
                    {ReactHtmlParser(gameData?.entry_message)}
                  </div>
                )}
              </div>
            </div>
            <div className="countdata mt-4 mb-4">
              <div className="gameweek-filter">
                <h4>Hub Numbers</h4>
              </div>
              <div className="container">
                <ul>
                  <li>
                    <div className="countbox">
                      <strong> {gameData?.team_size}</strong>
                      Team Size
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>
                        {gameData?.entry_price_symbol}
                        {gameData?.salary_cap}
                        {gameData?.default_salary_symbol ? "m" : ""}
                      </strong>
                      Salary Cap
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong> {gameData?.spots}</strong>
                      Game Spots
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>
                        {" "}
                        {gameData.round_start && (
                          <>{moment(gameData.round_start).format("D MMM")}</>
                        )}
                      </strong>
                      Starts
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>
                        {" "}
                        {gameData.round_end && (
                          <>{moment(gameData.round_end).format("D MMM")}</>
                        )}
                      </strong>
                      Ends
                    </div>
                  </li>
                </ul>
              </div>
              <div className="container">
                <ul>
                  <li>
                    <div className="countbox">
                      <strong>2x</strong>
                      Captain
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>1.5x</strong> V-Captain
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>{gameData.trades}</strong> Trades
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      {gameData?.collect_game_pass === 0 && (
                        <>
                          <strong>Free</strong> Entry Fee{" "}
                        </>
                      )}
                      {gameData?.collect_game_pass === 1 && (
                        <>
                          <strong>{gameData?.game_pass_fee}</strong> Entry Fee{" "}
                        </>
                      )}
                    </div>
                  </li>
                  <li>
                    <div className="countbox">
                      <strong>
                        {gameData?.game_type === 1 && "Club"}
                        {gameData?.game_type === 2 && "League"}
                        {gameData?.game_type === 3 && "Indoor"}
                        {gameData?.game_type === 4 && "Match"}
                      </strong>{" "}
                      Mode
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link active`}
                  id="overall-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#overall"
                  type="button"
                  role="tab"
                  aria-controls="overall"
                  aria-selected="true"
                >
                  Rounds
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="round-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#round"
                  type="button"
                  role="tab"
                  aria-controls="round"
                  aria-selected="true"
                  onClick={fetchTradeData}
                >
                  Trades Window
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="point-system-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#point-system"
                  type="button"
                  role="tab"
                  aria-controls="point-system"
                  aria-selected="true"
                  // onClick={fetchTradeData}
                >
                  Point System
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="bonus-points-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#bonus-points"
                  type="button"
                  role="tab"
                  aria-controls="bonus-points"
                  aria-selected="true"
                  onClick={fetchBonusPoints}
                >
                  Bonus Points
                </button>
              </li>
            </ul>
            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="overall"
                role="tabpanel"
                aria-labelledby="overall-tab"
              >
                <div className="customscroll">
                  <div class="datefilter">
                    <ul className="currentround">
                      {currentRoundDetails && (
                        <li>
                          <div class="form-group startdate">
                            <label>
                              {" "}
                              {isCurrent === true ? " Current " : " Previous "}
                            </label>
                            <span>
                              R{currentRoundDetails?.round} (
                              {moment(currentRoundDetails?.start_date).format(
                                "MMM D, h:mma"
                              )}{" "}
                              -{" "}
                              {moment(currentRoundDetails?.end_date).format(
                                "MMM D, h:mma"
                              )}
                              )
                            </span>
                          </div>
                        </li>
                      )}
                      <li>
                        <div class="form-group enddate">
                          {nextRoundDetails && (
                            <>
                              <label>Next</label>
                              <span>
                                R{nextRoundDetails?.round + " "} (
                                {moment(nextRoundDetails?.start_date).format(
                                  "MMM D, h:mma"
                                )}{" "}
                                -{" "}
                                {moment(nextRoundDetails?.end_date).format(
                                  "MMM D, h:mma"
                                )}
                                )
                              </span>
                            </>
                          )}

                          {!nextRoundDetails && (
                            <>
                              <label> Next</label> <span> Completed</span>
                            </>
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <table className="table ranktable rankNewTableClass">
                      <thead>
                        <tr>
                          <th>Round</th>
                          <th>Start Day</th>
                          <th>End Day</th>
                          <th>Start Time</th>
                          <th>End Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {roundData.length > 0 &&
                          roundData.map((item, key) => (
                            <tr key={key}>
                              <td>{item.round}</td>
                              <td>
                                {moment(item.start_date).format("D.MM.YYYY")}
                              </td>
                              <td>
                                {moment(item.end_date).format("D.MM.YYYY")}
                              </td>
                              <td>
                                {moment(item.start_date).format("h:mm A")}
                              </td>
                              <td>{moment(item.end_date).format("h:mm A")}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="round"
                role="tabpanel"
                aria-labelledby="round-tab"
              >
                <div className="customscroll">
                  <div className="datefilter">
                    <ul className="currentround">
                      {currentTradeWindowDetails && (
                        <li>
                          <div class="form-group startdate">
                            <label>
                              {" "}
                              {isCurrent === true ? " Current " : "Previous"}
                            </label>
                            <span>
                              TW{currentTradeWindowDetails?.round} (
                              {moment(
                                currentTradeWindowDetails.trade_start
                              ).format("MMM D, h:mma")}{" "}
                              -{" "}
                              {moment(
                                currentTradeWindowDetails.trade_close
                              ).format("MMM D, h:mma")}
                              )
                            </span>
                          </div>
                        </li>
                      )}
                      <li>
                        <div class="form-group enddate">
                          {nextTradeWindowDetails && (
                            <>
                              <label>Next</label>
                              <span>
                                TW{nextTradeWindowDetails?.round + " "}(
                                {moment(
                                  nextTradeWindowDetails.trade_start
                                ).format("MMM D, h:mma")}{" "}
                                -{" "}
                                {moment(
                                  nextTradeWindowDetails.trade_close
                                ).format("MMM D, h:mma")}
                                )
                              </span>
                            </>
                          )}

                          {!nextTradeWindowDetails && (
                            <>
                              <label> Next</label> <span> Completed</span>
                            </>
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <table className="table ranktable rankNewTableClass">
                      <thead>
                        <tr>
                          <th>Trade Window</th>
                          <th>Start Day</th>
                          <th>End Day</th>
                          <th>Start Time</th>
                          <th>End Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lockoutList &&
                          lockoutList.map((item, key) => (
                            <tr key={key}>
                              <td>{++key}</td>
                              <td>
                                {moment(item.trade_start).format("D.MM.YYYY")}
                              </td>
                              <td>
                                {moment(item.trade_close).format("D.MM.YYYY")}
                              </td>
                              <td>
                                {moment(item.trade_start).format("h:mm A")}
                              </td>
                              <td>
                                {moment(item.trade_close).format("h:mm A")}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="point-system"
                role="tabpanel"
                aria-labelledby="point-system-tab"
              >
                <div className="customscroll">
                  <div className="searchfilter">
                    <select
                      id="gradeSelect"
                      value={selectedGrade}
                      onChange={(e) => handleGradeChange(e.target.value)}
                      className="selectdropdown"
                    >
                      <option value="">Select</option>{" "}
                      {/* Add a default option */}
                      {gradeList.map((item, key) => (
                        <option key={key} value={item?.id}>
                          {item?.grade}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <table className="table ranktable rankNewTableClass">
                      <thead>
                        <tr>
                          <th>CATEGORY</th>
                          <th>BOWL</th>
                          <th>BAT</th>
                          <th>WK</th>
                          <th>AR</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pointsListing &&
                          pointsListing.map(
                            (item, key) =>
                              (item?.bowler !== "0" ||
                                item?.bats !== "0" ||
                                item?.wk !== "0" ||
                                item?.ar !== "0") && (
                                <tr key={key}>
                                  <td>{item?.attribute_name}</td>
                                  <td>{item?.bowler}</td>
                                  <td>{item?.bats}</td>
                                  <td>{item?.wk}</td>
                                  <td>{item?.ar}</td>
                                </tr>
                              )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="bonus-points"
                role="tabpanel"
                aria-labelledby="bonus-points-tab"
              >
                <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                  <div className="customscroll">
                    <table className="table ranktable rankNewTableClass">
                      <thead>
                        <tr>
                          <th>Team Name</th>
                          <th>POTM</th>
                          <th>Match Win</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bonusPoints &&
                          bonusPoints.map((item, key) => (
                            <tr key={key}>
                              <td>{item.name}</td>
                              <td>{item.potm_bonus}</td>
                              <td>{item.match_bonus}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="block-section">
              <div className="left-block" style={{ width: "100%" }}>
                <div className="row">
                  <div className="col-md-4 col-6">
                    <div className="whitebox">
                      <div className="quicklink aboutgame">
                        <div className="boxheading">
                          <h4>Game Info</h4>
                        </div>
                        <ul>
                          <li>
                            Teams Entered{" "}
                            <span>{game_info_block_data?.teamEntered}</span>
                          </li>
                          <li>
                            Players Added{" "}
                            <span>{game_info_block_data?.totalPlayer}</span>
                          </li>
                          <li>
                            Trades Used
                            <span>{game_info_block_data?.game_trade_used}</span>
                          </li>
                          <li>
                            Player Views
                            <span>
                              {game_info_block_data?.player_profile_views}
                            </span>
                          </li>
                          <li>
                            Gameviews
                            <span>{game_info_block_data?.gameViews}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-6">
                    <div className="whitebox">
                      <div className="quicklink aboutgame">
                        <div className="boxheading">
                          <h4>PRO Add-Ons</h4>
                        </div>
                        <ul>
                          <li>
                            {"Bonus Cards"}
                            {gameData?.is_bonus_card_activate == 1 && (
                              <span style={{ color: "green" }}>Active</span>
                            )}
                            {gameData?.is_bonus_card_activate == 0 && (
                              <span style={{ color: "red" }}>In-Active</span>
                            )}
                          </li>
                          <li>
                            {"Team of the Round"}

                            {gameData?.is_totr_activate == 1 && (
                              <span style={{ color: "green" }}>Active</span>
                            )}
                            {gameData?.is_totr_activate == 0 && (
                              <span style={{ color: "red" }}>In-Active</span>
                            )}
                          </li>
                          <li>
                            Head-2-Head
                            {gameData?.is_h2h_activate == 1 && (
                              <span style={{ color: "green" }}>Active</span>
                            )}
                            {gameData?.is_h2h_activate == 0 && (
                              <span style={{ color: "red" }}>In-Active</span>
                            )}
                          </li>
                          <li>
                            Bracket Battle
                            {gameData?.is_bracket_battle_activate == 1 && (
                              <span style={{ color: "green" }}>Active</span>
                            )}
                            {gameData?.is_bracket_battle_activate == 0 && (
                              <span style={{ color: "red" }}>In-Active</span>
                            )}
                          </li>
                          <li>
                            Vote Count
                            {gameData?.is_voting_activate == 1 && (
                              <span style={{ color: "green" }}>Active</span>
                            )}
                            {gameData?.is_voting_activate == 0 && (
                              <span style={{ color: "red" }}>In-Active</span>
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-6">
                    <div className="whitebox">
                      <div className="quicklink">
                        <div className="boxheading">
                          <h4>Quick Links</h4>
                        </div>
                        <ul>
                          <li>
                            <Link
                              className="dropdown-item"
                              to={`https://myclubtap.tawk.help/category/for-members`}
                              target="_blank"
                            >
                              Help Center
                            </Link>
                          </li>
                          <li>
                            <Link to={"/how-to-play"}>How to Play</Link>
                          </li>
                          <li>
                            <Link to={"/game-charts"}>Game Charts</Link>
                          </li>
                          <li>
                            <Link to={"/rules"}>Rules</Link>
                          </li>
                          <li>
                            {" "}
                            <Link to={"/faqs"}>FAQs</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutGame;
